var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{attrs:{"subheader":""}},_vm._l((_vm.rows),function(r,i){return _c('v-list-item',{key:i,staticStyle:{"min-height":"20px"}},[_c('v-list-item-content',{staticClass:"py-2"},[_c('v-list-item-title',[_vm._v(_vm._s(r))])],1)],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }